import getStringTemplateFromSku from './getStringTemplateFromSku';

function getPixleeContentFromSku (albumConfig) {

	const URL = getStringTemplateFromSku(albumConfig);
	return fetch(URL, {
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json; charset=utf-8'
		},
		method: 'GET',
		cache: 'no-cache'
	}).then((response) => response.json());

}

export default getPixleeContentFromSku;
